import { CardsContainer } from "components/CardsContainer";
import { LARGE } from "shared/constants";
import { MaxWidth } from "components/MaxWidth";
import styles from "./CardsSection.module.css";

export const CardsSectionContainer = ({ title, items }) => (
  <MaxWidth size={LARGE}>
    <div className={styles.container}>
      <CardsContainer title={title} items={items} />
    </div>
  </MaxWidth>
);
